export const getTZOffsetNumber = (timezoneName = null) => {
  const tz = timezoneName || getUserTZString();
  const now = new Date();

  // Формируем дату в указанном часовом поясе
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    timeZoneName: 'longOffset'
  });

  // Получаем строку со смещением (например "GMT+3" или "GMT+06:00")
  const parts = formatter.formatToParts(now);
  const offsetPart = parts.find(part => part.type === 'timeZoneName');

  if (offsetPart && offsetPart.value.startsWith('GMT')) {
    const offsetStr = offsetPart.value.replace('GMT', '');
    // Парсим формат +3, +06:00, -5, -03:30 и т.д.
    const match = offsetStr.match(/([+-])(\d{1,2})(?::(\d{2}))?/);
    if (match) {
      let hours = parseInt(match[2], 10);
      const minutes = match[3] ? parseInt(match[3], 10) : 0;
      const sign = match[1] === '+' ? 1 : -1;
      return sign * (hours + minutes / 60);
    }
  }

  // Fallback: вычисляем смещение через разницу с UTC
  const utcDate = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' }));
  const tzDate = new Date(now.toLocaleString('en-US', { timeZone: tz }));
  const offsetHours = (tzDate - utcDate) / (1000 * 60 * 60);
  return offsetHours;
};

export const getUserTZString = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return 'Europe/Moscow';
    // return 'UTC'; 
  }
};

export const userTZNumber = getTZOffsetNumber();

export const convertTimezone = (dateStr, fromOffset, toOffset) => {
  const date = new Date(dateStr);
  if (dateStr.endsWith('Z')) return date;
  // Считаем разницу в часах между пользователем и скважиной
  const diffHours = toOffset - fromOffset;
  // Применяем сдвиг к миллисекундам (безопаснее, чем setHours)
  return new Date(date.getTime() + diffHours * 60 * 60 * 1000);
};

export const convertTimezoneFromUTC = (utcValue) => {
  if (utcValue === null || utcValue === undefined) {
    return utcValue;
  }
  return utcValue - userTZNumber;
};

export const convertTimezoneToUTC = (localValue) => {
  if (localValue === null || localValue === undefined) {
    return localValue;
  }
  return localValue + userTZNumber;
};